import { render, staticRenderFns } from "./PostsContainer.vue?vue&type=template&id=58f8b189&scoped=true"
import script from "./PostsContainer.vue?vue&type=script&lang=js"
export * from "./PostsContainer.vue?vue&type=script&lang=js"
import style0 from "./PostsContainer.vue?vue&type=style&index=0&id=58f8b189&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58f8b189",
  null
  
)

export default component.exports